'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isNull2 = require('lodash/isNull');

var _isNull3 = _interopRequireDefault(_isNull2);

exports.Radio = Radio;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../utils/style');

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _layout = require('../layout');

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

var _constants = require('./constants');

var _radio = require('./radio.css');

var _radio2 = _interopRequireDefault(_radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Radio(props) {
  var _cx, _cx2;

  var _props$checked = props.checked,
      checked = _props$checked === undefined ? false : _props$checked,
      _props$size = props.size,
      size = _props$size === undefined ? 'medium' : _props$size,
      disabled = props.disabled,
      readonly = props.readonly,
      label = props.label,
      onClick = props.onClick,
      name = props.name,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['checked', 'size', 'disabled', 'readonly', 'label', 'onClick', 'name']);


  return _react2.default.createElement(
    _layout.Flex,
    {
      alignItems: 'center',
      justifyContent: 'start',
      onClick: readonly || disabled ? null : onClick,
      name: name,
      role: 'radio',
      'aria-checked': checked,
      'aria-disabled': disabled,
      className: (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _radio2.default.root, true), (0, _defineProperty3.default)(_cx, _radio2.default.disabled, disabled), (0, _defineProperty3.default)(_cx, _radio2.default.readonly, readonly), _cx))
    },
    _react2.default.createElement(
      _layout.Box,
      (0, _extends3.default)({
        position: 'relative',
        width: _constants.RADIO_SIZES.properties[size].size,
        height: _constants.RADIO_SIZES.properties[size].size,
        className: (0, _classnames2.default)((_cx2 = {}, (0, _defineProperty3.default)(_cx2, _radio2.default.radio, true), (0, _defineProperty3.default)(_cx2, _radio2.default.checked, checked), _cx2))
      }, (0, _style.pickStyles)(otherProps), otherProps),
      _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        {
          transitionName: 't-scale',
          transitionEnterTimeout: 300,
          transitionLeaveTimeout: 300
        },
        checked || (0, _isNull3.default)(checked) ? _react2.default.createElement(_layout.Inline, {
          position: 'absolute',
          className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _radio2.default.icon, true))
        }) : null
      )
    ),
    label ? _react2.default.createElement(
      _text2.default,
      { marginLeft: 10, size: 'small', color: 'navy700', component: 'label' },
      label
    ) : null
  );
}

exports.default = Radio;


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/radio/radio.js
// module id = 348
// module chunks = 114276838955818